import React from 'react';
import { Input } from 'antd';
import PropTypes from 'prop-types';

const DigitInput = ({ value, onChange, maxLength , ...rest }) => {
  const handleChange = (e) => {
    const rawValue = e.target.value;
    let cleanedValue = rawValue.replace(/\D/g, '');
    if (maxLength) {
      cleanedValue = cleanedValue.slice(0, maxLength);
    }
    onChange?.(cleanedValue);
  };

  return (
    <Input
      {...rest}
      value={value}
      onChange={handleChange}
      maxLength={maxLength}
      inputMode='numeric'
    />
  );
};

DigitInput.propTypes = {
  maxLength: PropTypes.number,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default DigitInput;
